<template>
  <div class="overviewmap" style="height:100%;background-color:#f7f7f7;" v-if="loaded">
    <div class="row" v-if="title">
      <div class="col">
        <div class="map-wrap">
          <div class="row">
            <div class="col-sm-auto">
              <h4>{{title}}</h4>
            </div>
            <div class="col text-right layer-commands">
              <!-- <a v-if="!nodata" v-bind:href="downloadUrl" class="btn btn-layer" ><i class="fas fa-download"></i></a> -->
            </div>
          </div>

          <div v-if="!nodata" ref="map" class="map" style="height:400px;width:100%;"></div>

          <div v-if="nodata" style="height:400px;width:100%;background-color:#e5e5e5;"><p style="margin:auto;padding-top:180px;width:60%;text-align:center;color:#555;">No data was found for this map. Perhaps this country has no Level-2 Administrative units?</p></div>

          <div class="row no-gutters">
            <div class="legend-wrapper">
                <slot></slot>
            </div>
          </div>

          <div class="row no-gutters" v-if="attribution">
            <p class="attribution">Map: Geofolio. {{attribution}}</p>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Leaflet from 'leaflet';
import "leaflet/dist/leaflet.css";

import _ from 'lodash'; 

import omnivore from "@mapbox/leaflet-omnivore";
export default {
    name: 'AdministrativeMap',
    components: { },
    props: ['location', 'source', 'download', 'title', 'description', 'layout', 'attribution', 'factsheet', 'loaded', 'label', 'sublabel'],
    data() {
        return {
            background: 'OpenStreetMap',
            legend: null,
            nodata: false
        }
    },
    mounted() {
      this.loadMap();
    },
    watch: {
      location() {
        //this.loadMap();
      },
      loaded() {
        if(this.loaded) {
          this.loadMap()
        }
      }
    },
    methods: {
      loadMap() {
        var dataset_id = this.factsheet.dataset_ids['gadm_summary']
        var dataset_path = this.factsheet.dataset_paths['gadm_summary'];
        var gadmUrl = process.env.VUE_APP_API+'/data/factsheet'+dataset_path+'/'+this.source;

        this.$axios.get(gadmUrl).then((response) => {
          console.log("Finished loading gadm data!")
          /* Check that we've actually found some features in the data. */
          if (response.data.features.length > 0) {
            /* Set up the main map */
            this.map = L.map(this.$refs.map, { 
              'attributionControl': false, 
              'scrollWheelZoom': false }
            );
            L.control.scale().addTo(this.map);

            var backgroundUrl = process.env.VUE_APP_API+'/tools/layer/'+this.background+'/v1?z={z}&x={x}&y={y}'

            this.mapBackground = L.tileLayer(backgroundUrl, {
              attribution: '',
              maxZoom: 18,
              id: 'mapBackground'
            }).addTo(this.map);

            var this_ = this;
            var opts = {
                style: function(layer) {
                  const colors = ["#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd","#8c564b","#e377c2","#7f7f7f","#bcbd22","#17becf"]
                  return {
                    "color": "#000",
                    "fillColor": colors[layer.properties.ix % 10],
                    "weight": 2,
                    "opacity": 1,
                    "fillOpacity": 0.2
                  }
                },
                interactive: false,
                onEachFeature: (feature, layer) => {
                  layer.bindTooltip("<strong>"+feature.properties[this.label]+"</strong><br/><small>"+feature.properties[this.sublabel]+" (ADM-1, "+feature.properties.adm0_name+")</small>", {
                    permanent: true,
                    sticky: true,
                    direction: 'center',
                    className: 'gadmLabel'
                  });
                }
            }
            this.gadm = new L.geoJSON(response.data, opts).addTo(this.map);
            this.map.fitBounds(this.gadm.getBounds()).panTo(this.location.center);
            _.cloneDeep(this.location.layer).addTo(this.map);
            this.nodata = false;
          } else {
            console.log("No data for this map!!")
            this.nodata = true;
          }
      });
      },
    },
    computed: {
      downloadUrl() {
        return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/gadm_summary/gadm_level1.geojson';
      }
    }
}
</script>
<style>
div.gadmLabel {
  padding:1px 5px 1px 5px;
  border:0px solid #000;
  border-radius:4px;
  font-size:0.9em;
  box-shadow:none;
}
</style>

<style scoped>

div.overviewmap {
  margin:0px 0px 0px 0px;
}
h4 {
  margin:0px;
  padding:8px;
  padding-left:10px;
  font-size:0.9em;
  width:100%;
  color:#444;
}
h5 {
  font-size:0.7em;
  color:#666;
  font-weight:600;
  padding:5px 0px 10px 0px;
  margin:0px;

}
p {
  margin:0px;
  font-size:0.6em;
  color:#222;
}
p.attribution {
  font-size:0.5em;
  padding:0px 6px 3px 6px;
  color:#888;
}
div.cmd, div.row {
  
}
div.map-wrap {
 background-color:#f5f5f5; 
}
a.btn-command:focus, a.btn-command:active {
  outline:none !important;
  box-shadow:none;
} 
a.btn-command {
  background-color:#f5f5f5;
  color:#999;
}
a.btn-command:hover {
  background-color:#eeeeee;
  color:#777;
}
a.btn-command i {
  font-size:0.8em;
}
div.legend-wrapper {
  padding:7px;
}
div.layer-commands {
  margin-top:3px;
  font-size:1em;
}
div.layer-commands a.btn-layer {
  color:#aaa;
}
div.layer-commands a.btn-layer:hover {
  color:#0056b3;
}
.btn:focus,.btn:active {
   outline: none !important;
   box-shadow: none;
}
</style>